import M from 'materialize-css/dist/js/materialize';
import * as mdrAction from '../actions/mdrAction';
import HttpService from './HttpService';
import { getUrlMdrApi, translate } from '../utils/util';
import { endLoading } from '../actions/loadingAction';
import * as volumeAction from '../actions/volumeAction';

const httpService = new HttpService(getUrlMdrApi(window));

export default class MdrService {
    static search(idFornecedor, callback) {
        if (navigator.onLine) {
            const url = '/api/RackCodePartnumber/SearchRackCodeSupplier';

            return (dispatch) => {
                httpService.instance.post(url, { supplierCode: parseInt(idFornecedor) }).then((response) => {
                    dispatch(mdrAction.clearMdrList());
                    dispatch(mdrAction.updateMdrList(response.data));
                    callback();
                }).catch((error) => {
                    dispatch(endLoading());
                    M.toast({ html: error.message, classes: 'red' });
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        } else {
            M.toast({ html: 'Verificar conexão!', classes: 'red' });
        }

        callback();
    }

    static getVolume(filter) {
        const url = '/api/TypologyPackaging';
        return (dispatch) => {
            if (navigator.onLine) {
                httpService.instance.get(
                    url,
                    {
                        params: filter,
                        timeout: process.env.REACT_APP_DEFAULT_REQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response.status === 200) {
                        dispatch(volumeAction.setPacking(response.data.data));
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static live(callback) {
        const url = '/api/Live';
        return () => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    callback(response);
                }).catch((error) => {
                    callback(error);
                })
            }
        };
    }

    static selectMdrItem(mdrtItem) {
        return (dispatch) => {
            const item = {};
            Object.assign(item, mdrtItem);
            item.supplierCode = mdrtItem.supplierCode;
            item.rackCode = mdrtItem.rackCode;
            item.rackCodeDescription = mdrtItem.rackCodeDescription;
            item.qtdRackCode = null;
            item.qtdVolume = null;
            dispatch(mdrAction.selectMdrItem(item));
        };
    }

    static clearMdrList() {
        return (dispatch) => {
            dispatch(mdrAction.clearMdrList());
        };
    }
}
